import { axiosInstance } from "../../../api/axiosInstance";
import { appCache } from "../../../cache/appCache";
import { Subject } from "../types";

// Cached (appCache bucket "subjects")
export const fetchSubjects = (): Promise<Subject[]> =>
  appCache.getOrFetch("subjects", () => axiosInstance.get<Subject[]>("/subjects").then((response) => response.data));

export const createSubject = async (subject: Subject): Promise<Subject> => {
  const response = await axiosInstance.post<Subject>("/subjects", subject);
  appCache.invalidate("subjects");
  return response.data;
};

export const updateSubject = async (
  code: string,
  subject: Pick<Subject, "name" | "description">
): Promise<Subject> => {
  const response = await axiosInstance.put<Subject>(
    `/subjects/${encodeURIComponent(code)}`,
    subject
  );
  appCache.invalidate("subjects");
  return response.data;
};

export const deleteSubject = async (code: string): Promise<void> => {
  await axiosInstance.delete(`/subjects/${encodeURIComponent(code)}`);
  appCache.invalidate("subjects");
};
